import { render, staticRenderFns } from "./ShopSett.vue?vue&type=template&id=5b402dac&scoped=true&"
import script from "./ShopSett.vue?vue&type=script&lang=js&"
export * from "./ShopSett.vue?vue&type=script&lang=js&"
import style0 from "./ShopSett.vue?vue&type=style&index=0&id=5b402dac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b402dac",
  null
  
)

export default component.exports